module.exports = __webpack_public_path__ + "img/green-circle-table-2.c3711ba3.png";